module.exports = __webpack_public_path__ + "media/images/www/company/warehouse-cart-packages-a0d054cc9a5e1a269f936cb31ed76a68.svg";